<template>
    <div class="month-switcher">
        <button :disabled="isPrevMonthDisabled" type="button" :class="previousButtonClass" @click="changeMonth(-1)">
            <common-icon name="arrow-left" size="small"></common-icon>
        </button>

        <span :class="labelClass">
            {{ currentMonth.format('MMMM YYYY') }}
        </span>

        <button :disabled="isNextMonthDisabled" type="button" :class="nextButtonClass" @click="changeMonth(+1)">
            <common-icon name="arrow-right" size="small"></common-icon>
        </button>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        props: {
            value: { type: Object, required: true },
            size: { type: String, required: true },
            disableMonths: { type: Boolean, default: true },
        },

        computed: {
            currentMonth() {
                return dayjs().startOf('month').year(this.value.year).month(this.value.month)
            },

            isPrevMonthDisabled() {
                return (
                    this.currentMonth.format() === dayjs().startOf('month').format() &&
                    this.size !== 'small' &&
                    this.disableMonths
                )
            },

            isNextMonthDisabled() {
                return (
                    this.currentMonth.format() === dayjs().add(11, 'months').startOf('month').format() &&
                    this.size !== 'small' &&
                    this.disableMonths
                )
            },
            nextButtonClass() {
                return {
                    'month-switcher__next': true,
                    [`month-switcher__next--${this.size}`]: true,
                }
            },
            previousButtonClass() {
                return {
                    'month-switcher__prev': true,
                    [`month-switcher__prev--${this.size}`]: true,
                }
            },
            labelClass() {
                return {
                    'month-switcher__name': true,
                    [`month-switcher__name--${this.size}`]: true,
                }
            },
        },

        methods: {
            changeMonth(direction) {
                const newMonth = this.currentMonth.add(direction, 'month')

                this.emitEvent({
                    name: 'change',
                    payload: {
                        year: newMonth.year(),
                        month: newMonth.month(),
                    },
                })
            },
        },
    }
</script>
